import {createI18n} from "vue-i18n";
import {messages} from "@/locales";

// Create i18n instance with options
export const i18n = createI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
})
